"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePreviousDefined = void 0;
var react_1 = __importDefault(require("react"));
function usePreviousDefined(value) {
    var ref = react_1.default.useRef({ current: value, previous: value });
    react_1.default.useEffect(function () {
        if (ref.current.current !== value) {
            ref.current.previous = ref.current.current;
            ref.current.current = value;
        }
    }, [value]);
    return ref.current.previous;
}
exports.usePreviousDefined = usePreviousDefined;
